module.exports = __webpack_public_path__ + "static/images/icon-popup2.9225cb5.png";